import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "1-trend-11-left1",
  "use": "1-trend-11-left1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"1-trend-11-left1\">\n  <path d=\"M735.208665 65.582671l-446.41733 446.417329 446.41733 446.417329z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol